<template>
    <div class="card card-transparent card-rounded">
        <div class="card-header">
            <h5 class="card-title">{{transEdit('welcome')}} <b>{{therapist_name}}</b>
                <a class="heading-elements-toggle"><i class="icon-more"></i></a></h5>
            <div class="heading-elements">
                <ul class="icons-list">

                </ul>
            </div>
        </div>

        <div class="card-body">
            <div class="row">
                <div class="col-md text-center customer-start-icon">
                    <a :href="$portalUrl(route_surveys)"><i class="fa fa-edit fa-2x"></i><br>
                        <span>{{transEdit('nki-result')}}</span></a></div>
                <div class="col-md text-center customer-start-icon">
                    <a :href="route_reporting"><i class="fa fa-file-text-o fa-2x"></i><br>
                        <span>{{transEdit('reporting')}}</span></a></div>
                <div class="col-md text-center customer-start-icon">
                    <a :href="route_absence"><i class="fa fa-ambulance fa-2x"></i><br>
                    <span>{{transEdit('report-absent')}}</span></a></div>
                <div class="col-md text-center customer-start-icon">
                    <a :href="route_settings"><i class="fa fa-cog fa-2x"></i><br>
                    <span>{{transEdit('settings')}}</span></a></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'part'
        ],
        name: "therapist-dash-intro",
        computed: {
            route_reporting: function () {
                return this.part.route_reporting_page;
            },
            route_absence: function () {
                return this.part.route_absence_page;
            },
            route_settings: function () {
                return this.part.route_settings_page;
            },
            route_surveys: function () {
                return this.part.route_surveys_page;
            },
            therapist_name: function () {
                return this.part.therapistname;
            }
        }
    }
</script>

<style scoped>

</style>